<template>
  <main class="c-main">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <header class="card-header">
            <button class="btn btn-success" @click="modalChange({modal:'add',visible:true})">Добавить пользователя
            </button>
            <h4 class="pull-right">Пользователи</h4>
          </header>
          <div class="card-body">
            <table class="table table-bordered table-striped" id="serverDataTable">
              <thead>
              <tr>
                <th>username</th>
                <th>Имя</th>
                <th>E-mail</th>
                <th>телефон</th>
                <th>Тип</th>
                <th>Действие</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(user, index) in users" :key="index">
                <td>{{ user.name }}</td>
                <td>{{ user.first_name }}</td>
                <td>{{ user.email }}</td>
                <td>{{ user.phone }}</td>
                <td>
                  <span
                      v-for="role in user.roles"
                      class="bg-indigo text-white p-1 mr-1 rounded"
                  >
                    {{ role }}
                  </span>
                </td>
                <td>
                  <button class="btn btn-info mr-1"
                          @click="modalChange({modal:'watch',visible:true,user_id:user.id})">
                    посмотреть
                  </button>
                  <button class="btn btn-warning"
                          @click="modalChange({modal:'edit',visible:true,user_id:user.id})">
                    Изменить
                  </button>
                  <a
                      href="javascript:void(0);"
                      @click="deleteUser(user.id)"
                      class="btn btn-danger ml-1"
                  >Удалить</a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <userAdd
          :showUserAddModal="showUserAddModal"
          :user="user"
          :roles="roles"
          @update="modalChange"
      ></userAdd>
      <userEdit
          :user="user"
          :roles="roles"
          :showUserEditModal="showUserEditModal"
          @update="modalChange"
      ></userEdit>
      <userWatch
          :user="user"
          :showUserWatchModal="showUserWatchModal"
          @update="modalChange"
      ></userWatch>
    </div>
  </main>
</template>

<script>
import {GET, DELETE, POST} from "@/shared/api";
import userAdd from "@/views/user/modals/userAdd";
import userEdit from "@/views/user/modals/userEdit";
import userWatch from "@/views/user/modals/userWatch";

export default {
  components: {userAdd, userEdit, userWatch},
  data() {
    return {
      showUserWatchModal: false,
      showUserEditModal: false,
      showUserAddModal: false,
      users: [],
      roles: [],
      user: {},
      confirmation: false
    };
  },
  methods: {
    modalChange(state) {
      switch (state.modal) {
        case "add": {
          this.showUserAddModal = state.visible;
          break;
        }
        case "watch": {
          this.showUserWatchModal = state.visible;
          if (this.showUserWatchModal) {
            this.getUser(state.user_id);
          } else {
            this.user = {};
          }
          break;
        }
        case "edit": {
          this.showUserEditModal = state.visible;
          if (this.showUserEditModal) {
            this.getUser(state.user_id);
          } else {
            this.user = {};
          }
          break;
        }
        case "stored": {
          this.showUserAddModal = false;
          this.getUsers();
          this.user = {};
          break;
        }
        case "updated": {
          this.showUserEditModal = false;
          this.getUsers();
          this.user = {};
          break;
        }

      }
    },
    getUsers() {
      GET({append: ["roles"]}, "/user", this, false).then(response => {
        this.users = response;
      });
    },
    getRoles() {
      GET([],"/role", this, false).then(response => {
        this.roles = response;
      });
    },
    getUser(user_id) {
      GET([], "/user/" + user_id, this, false).then(response => {
        this.user = response;
      });
    },
    deleteUser(id) {
      DELETE(id, "/user/", this).then(response => {
        this.getUsers();
      });
    }
  },
  mounted() {
    this.getUsers();
    this.getRoles();
  }
};
</script>
